import {Tween} from '@gongxigames/framework/core/fragments/tween/Tween';
import {MovieClip} from '@gongxigames/framework/core/fragments/display';

export class MovieClipTween extends Tween {
    protected _mc: MovieClip;
    protected _fps: number;
    protected _loop: boolean;

    constructor(mc: MovieClip, fps = 0, loop = true) {
        super(mc);

        this._loop = loop;

        if (loop) {
            this.repeat(Infinity);
        }

        this._mc = mc;
        this._fps = fps;
        const frames = mc.frames.length;

        this._duration = frames * 1000 / this._fps;
    }

    public update(dt: number): void {
        if (!this._isPlaying) {
            return;
        }

        super.update(dt);

        const elapsed = (this._currentTime - this._startTime) / this._duration;

        if (elapsed >= 1) {
            if (this._loop) {
                const frame = Math.floor((elapsed % 1) * this._mc.frames.length);

                this._mc.gotoAndStop(frame + 1);
            }
        } else {
            const frame = Math.floor(elapsed * this._mc.frames.length);

            this._mc.gotoAndStop(frame + 1);
        }
    }

    public get mc(): MovieClip {
        return this._mc;
    }
}
